import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { JsonPropsType } from '../../component-loader';
import { Placeholder } from './products/placeholder';
import { V2_PRODUCT_REGISTRY } from './products/registry';
import { V2Product } from './types';

interface V2ProductPageData {
  product: V2Product;
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

export function V2ProductPage(props: JsonPropsType) {
  const { product } = props.jsonObject as V2ProductPageData;
  const PageComponent = V2_PRODUCT_REGISTRY[product.slug] ?? Placeholder;

  return (
    <QueryClientProvider client={queryClient}>
      <div className="playground-v2-product">
        <div className="mb-4">
          <h1 className="h3 mb-1">{product.name}</h1>
          <code className="text-secondary small">
            POST
            {' '}
            {product.path}
          </code>
        </div>
        <PageComponent product={product} />
      </div>
    </QueryClientProvider>
  );
}
